"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderDatePickerPopupContent = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _DateRangePicker = _interopRequireDefault(require("../../DateRangePicker"));

var _utils = require("../../utils");

var _interfaces = require("../interfaces");

var _core = require("@emotion/core");

var _excluded = ["ariaLabelsForSelectedDate", "close", "dateMarkerLegend", "datePickerProps", "handleValuesChange", "hasStartError", "hasEndError", "inputRole", "renderPopupContent", "selectedStartDate", "selectedEndDate", "setHasStartError", "setHasEndError", "setShouldFocusWithValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var renderDatePickerPopupContent = function renderDatePickerPopupContent(_ref) {
  var ariaLabelsForSelectedDate = _ref.ariaLabelsForSelectedDate,
      close = _ref.close,
      dateMarkerLegend = _ref.dateMarkerLegend,
      datePickerProps = _ref.datePickerProps,
      handleValuesChange = _ref.handleValuesChange,
      hasStartError = _ref.hasStartError,
      hasEndError = _ref.hasEndError,
      inputRole = _ref.inputRole,
      renderPopupContent = _ref.renderPopupContent,
      selectedStartDate = _ref.selectedStartDate,
      selectedEndDate = _ref.selectedEndDate,
      setHasStartError = _ref.setHasStartError,
      setHasEndError = _ref.setHasEndError,
      setShouldFocusWithValue = _ref.setShouldFocusWithValue,
      dataTestProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  // Disable all dates before start date on end date input
  var _isDateDisabled;

  if (inputRole === _interfaces.DateInputRole.EndDate && selectedStartDate) {
    var startDate = new Date(selectedStartDate);

    var isBeforeToday = function isBeforeToday(date) {
      return new Date(date) < startDate;
    };

    _isDateDisabled = isBeforeToday;
  }

  var pickerProps = _isDateDisabled ? _objectSpread(_objectSpread({}, datePickerProps), {}, {
    isDateDisabled: function isDateDisabled(date) {
      return !!_isDateDisabled && _isDateDisabled(date) || !!datePickerProps.isDateDisabled && datePickerProps.isDateDisabled(date);
    }
  }) : datePickerProps;

  var handlePickerChange = function handlePickerChange(startValue, endValue, closePopup) {
    !!startValue && setHasStartError(false);
    !!endValue && setHasEndError(false);
    handleValuesChange(startValue, endValue, closePopup);
    var value = inputRole === _interfaces.DateInputRole.StartDate ? startValue : endValue;

    if (value) {
      setShouldFocusWithValue(value);
    }
  }; // Date handler to be able to update start_date when a value has already been selected as
  // default behavior will just start a new selection if both dates are selected


  var handleStartDateSelection = function handleStartDateSelection(_ref2) {
    var date = _ref2.date,
        selectedEndDate = _ref2.selectedEndDate,
        setStateStartValue = _ref2.setStateStartValue,
        setStateEndValue = _ref2.setStateEndValue,
        onChange = _ref2.onChange,
        announceSelectionContext = _ref2.announceSelectionContext;

    // This encompasses the in which both dates have been selected and when date < end_date.
    // Also less than start_date or between start_date and end_date. Additionally, the case
    // when end_date has been selected and not start_date.
    if (selectedEndDate && date <= selectedEndDate) {
      setStateStartValue(date);
      !!onChange && onChange((0, _utils.dateToString)(date), (0, _utils.dateToString)(selectedEndDate));
    } else {
      // If the date is greater than end_date then just set start_date and end_date as undefined
      setStateStartValue(date);
      setStateEndValue(undefined);
      !!onChange && onChange((0, _utils.dateToString)(date), '');
    }

    announceSelectionContext({
      isStartDate: true
    });
  }; // Update end_date to a new value even if one already is set


  var handleEndDateSelection = function handleEndDateSelection(_ref3) {
    var date = _ref3.date,
        selectedStartDate = _ref3.selectedStartDate,
        setStateStartValue = _ref3.setStateStartValue,
        setStateEndValue = _ref3.setStateEndValue,
        onChange = _ref3.onChange,
        announceSelectionContext = _ref3.announceSelectionContext;

    // If isDateDisabled is passed then the case where date < start_date would
    // be possible so reset the selection and set the date to start_date
    if (selectedStartDate && date.getTime() < selectedStartDate.getTime()) {
      setStateStartValue(date);
      setStateEndValue(undefined);
      !!onChange && onChange((0, _utils.dateToString)(date), '');
      announceSelectionContext({
        isStartDate: true
      });
    } else {
      setStateEndValue(date);
      !!onChange && onChange((0, _utils.dateToString)(selectedStartDate), (0, _utils.dateToString)(date));
      announceSelectionContext({
        isEndDate: true
      });
    }
  };

  var handleDateSelection = inputRole === _interfaces.DateInputRole.StartDate ? handleStartDateSelection : handleEndDateSelection;
  var calendar = (0, _core.jsx)(_DateRangePicker.default, (0, _extends2.default)({}, pickerProps, {
    shouldFocusOnStartDate: inputRole === _interfaces.DateInputRole.StartDate,
    handleDateSelection: handleDateSelection,
    startValue: hasStartError ? '' : selectedStartDate,
    endValue: hasEndError ? '' : selectedEndDate,
    onChange: function onChange(startValue, endValue) {
      handlePickerChange(startValue, endValue, close);
    },
    ariaLabelsForSelectedDate: ariaLabelsForSelectedDate
  }, dataTestProps));
  return renderPopupContent({
    calendar: calendar,
    legend: dateMarkerLegend
  });
};

exports.renderDatePickerPopupContent = renderDatePickerPopupContent;